import {
  Typography, Card, Modal, Form, Flex, Input, Button
} from "antd";
import { useTranslation } from "react-i18next";
import classes from "./settings.module.css";
import { CANCEL_WORD } from "../../constants/app";
import useSettings from "./useSettings";

const { Title } = Typography;

const Settings = () => {
  const { t } = useTranslation();
  const {
    fullName,
    isEliminatePopupVisible,
    setIsEliminatePopupVisible,
    tabList,
    activeTabKey,
    contentList,
    onTabChange,
    loading,
    onSubmitForm,
    isDoctor
  } = useSettings();

  const eliminateForm = () => (
    <Form
      layout="inline"
      onFinish={onSubmitForm}
    >
      <Flex gap={8} style={{ width: "100%" }}>
        <Form.Item
          name="word"
          style={{ marginRight: 0, flexGrow: 1 }}
          rules={[
            () => ({
              validator(_, value) {
                if (value === CANCEL_WORD) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t("form.error.cancelWord")));
              },
            })]}
        >
          <Input/>
        </Form.Item>
        <Form.Item style={{ marginRight: 0 }}>
          <Button type="primary" loading={loading} disabled={loading} danger htmlType="submit">
            {t("settingsPage.deleteAccount.button")}
          </Button>
        </Form.Item>
      </Flex>
    </Form>
  );

  const eliminateButton = isDoctor
    ? undefined
    : (
      <Button
        type="link"
        size="large"
        danger
        onClick={() => setIsEliminatePopupVisible(true)}
      >
        {t("settingsPage.deleteAccount.tabLabel")}
      </Button>
    );

  return (
    <>
      <Title level={3}>{t("global.labels.welcome")} {isDoctor ? t("global.labels.doctorPrefix") : ""} {fullName}</Title>
      <Card
        onTabChange={onTabChange}
        tabList={tabList}
        tabBarExtraContent={eliminateButton}
        activeTabKey={activeTabKey}
        className={classes.tabs}
      >
        {contentList[activeTabKey]}
      </Card>
      {isDoctor ? null
        : (
          <Modal
            title={t("settingsPage.deleteAccount.title")}
            open={isEliminatePopupVisible}
            onCancel={() => setIsEliminatePopupVisible(false)}
            footer={eliminateForm}
          >
            <p>
              {t("settingsPage.deleteAccount.text")}
            </p>
            <p>{t("settingsPage.deleteAccount.infoText", { word: CANCEL_WORD })}</p>
          </Modal>
        )}
    </>
  );
};

export default Settings;
